module.exports = __webpack_public_path__ + "img/logo-avatar-white.8cd916c9.png";